import { render, staticRenderFns } from "./display-review.vue?vue&type=template&id=5723e808&scoped=true"
import script from "./display-review.vue?vue&type=script&lang=js"
export * from "./display-review.vue?vue&type=script&lang=js"
import style0 from "./display-review.vue?vue&type=style&index=0&id=5723e808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723e808",
  null
  
)

export default component.exports